import axios from "axios";
import { API_ORIGIN } from "../config/constants";

export class AuthService {
  static userLogin = async (email, password) => {
    try {
      let response = await axios({
        method: "POST",
        baseURL: API_ORIGIN + "/admin/login",
        data: {
          email: email,
          password: password,
        },
        headers: { "Content-Type": "application/json" },
      });

      let responseData = response.data.data;
      return responseData.admin.token;
    } catch (err) {
      throw err;
    }
  };
  static userDetails = async (token) => {
    try {
      let response = await axios({
        method: "GET",
        baseURL: API_ORIGIN + "/admin",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      let userInfo = response.data.data.admin;

      return userInfo;
    } catch (err) {
      throw err;
    }
  };
}
